import GravityAdapter from 'district-ui-client/adapters/gravity'

export default class GravitySchoolStatisticAdatper extends GravityAdapter {
  pathForType() {
    return 'statistics'
  }
}
